import axios, { AxiosError, AxiosRequestHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import baseApiUrl from '../Modules/environment-config';
import { refreshCognitoTokens } from './cognito';


const axiosAuth = axios.create({
    baseURL: baseApiUrl,
});

axiosAuth.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
        const token = localStorage.getItem('idToken');
        if (token) {
            if (config.headers) {
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                config.headers = { Authorization: `Bearer ${token}` } as AxiosRequestHeaders;
            }
        }
        return config;
    },
    (error: AxiosError): Promise<AxiosError> => {
        return Promise.reject(error);
    }
);

axiosAuth.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => response,
    async (error: AxiosError): Promise<AxiosError> => {
        if (error.response && error.response.status === 401) {
            try {
                // Handle token refresh logic
                await refreshCognitoTokens();
                // Retry the failed request
                return axiosAuth(error.config as InternalAxiosRequestConfig);
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);




export default axiosAuth;